import PlatformFeedback from "./PlatformFeedback";
import { usePlatformFeedback } from "./PlatformFeedbackProvider";

export default function PlatformFeedbackPortal() {
  const { open, product, eventType, closeFeedback } = usePlatformFeedback();

  return <PlatformFeedback open={open} onClose={closeFeedback} product={product} eventType={eventType} />;
}
